// import {forwardRef} from 'react';
import {
    AppBar as MuiAppBar,
    AppBarProps,
    Avatar,
    Button,
    IconButton,
    Toolbar,
    List,
    ListItem,
    ListItemSecondaryAction,
    Divider,
    Box,
    Switch,
    useColorScheme,
    Chip,
    useMediaQuery,
    useTheme,
} from '@mui/material';
import {
    Menu as MenuIcon,
    ExpandMore as ExpandMoreIcon,
    Logout as LogoutIcon,
    LightMode as LightIcon,
    DarkMode as DarkIcon,
    StorefrontOutlined as StoreIcon,
    // ChevronRightOutlined as GoToIcon,
    KeyboardDoubleArrowRight as GoToIcon,
    SaveAlt as Download,
    LoginOutlined,
    DarkMode,
    LightMode,
} from '@mui/icons-material';
import { useEffect, useRef, useState, MouseEvent } from 'react';
import AppBarExtendMenu from './components/AppBarExtendMenu';
import ListItemLink from '@/layouts/ManagerLayout/components/ListItemLink';
import MenuItemLink from '@/layouts/ManagerLayout/components/MenuItemLink';
import ListItemIcon from '@mui/material/ListItemIcon';
import ListItemText from '@mui/material/ListItemText';

import { useCurrentMallStore, useSpaceUserV2Store } from '@/store';
import { env, services } from '@/constant/configure';
import { saveAs } from 'file-saver';
import { Link, useLoaderData, useNavigate } from 'react-router-dom';
import userStore from '@/store/modules/userStore';
import sessionStore from '@/store/modules/sessionStore';
import BasicSwitch from '@/components/common/BasicSwitch';
import { defaultUserImage } from '@/constant/image';
import ConfirmMallOpenDialog from '@/components/ConfirmMallOpenDialog';
import { dialogClear, dialogOpen } from '@/modules/MuiDialog';

interface Props extends AppBarProps {
    isDrawerOpen: boolean;
    setIsDrawerOpen: Function;
    setAppBarHeight?: Function;
}
const AppBar = (props: Props) => {
    const { setIsDrawerOpen, isDrawerOpen, setAppBarHeight = () => {} } = props;
    const elRef = useRef<HTMLDivElement>(null);
    const { nickname } = userStore.getState();
    const { userId } = sessionStore.getState();
    const { path, profile_img_url, spacehome_create_step } = useSpaceUserV2Store();

    const { is_mall_opened = false } = useLoaderData() as any;
    // const [anchorEl,] = useState<null | HTMLElement>(null);
    const menuTriggerRef = useRef<HTMLButtonElement>(null);
    const [isOpenExtend, setIsOpenExtend] = useState(false);
    const navigate = useNavigate();
    // const isOpenExtend = Boolean(anchorEl);
    const { mode, setMode } = useColorScheme();
    const theme = useTheme();
    const isMobile = useMediaQuery(theme.breakpoints.down('md'));

    const { backgroundImage, backgroundColor } = useCurrentMallStore();

    const toggleMenu = () => {
        setIsOpenExtend(!isOpenExtend);
    };

    useEffect(() => {
        if (!!elRef.current) {
            setAppBarHeight(elRef?.current?.clientHeight || 64);
        }
    });
    return (
        <MuiAppBar ref={elRef} color={'black'} position={'sticky'} sx={{ zIndex: (theme) => theme.zIndex.drawer + 1 }}>
            <Toolbar>
                <IconButton
                    color={'inherit'}
                    onClick={() => {
                        setIsDrawerOpen((prev: boolean) => !prev);
                    }}
                >
                    <MenuIcon />
                </IconButton>
                <h1 className={'grow items-center flex'}>
                    <div>
                        <span className="text-h6 mr-4">
                            <Link to={'/'}>
                                플로잉 후킹스프
                                {env !== 'prd' ? ' DEV' : ''}
                            </Link>
                        </span>
                    </div>

                    <div className="flex gap-2 ml-4">
                        {/* <Button
                            variant='contained'
                            href={`/home`}
                            color="sellerColor"
                        >
                            상품소싱
                        </Button> */}
                        <Button
                            // href={`/studio/${userId}`}
                            color="sellerColorInvert"
                            variant="contained"
                            onClick={() => {
                                if (!!userId) {
                                    navigate(`/studio/${userId}`);
                                } else {
                                    dialogOpen({
                                        title: '로그인이 필요합니다.',
                                        message: '로그인하러 갈까요?',
                                        onConfirmed: async () => {
                                            navigate('/login');
                                            dialogClear();
                                        },
                                        confirmText: '로그인하러 가기',
                                        disableBackdropClick: true,
                                        maxWidth: 'xs',
                                    });
                                }
                            }}
                        >
                            프로필링크
                        </Button>
                        <Button
                            // href={`/switch`}
                            onClick={() => {
                                if (!!userId) {
                                    if (!!is_mall_opened) {
                                        navigate('/switch');
                                    } else {
                                        dialogOpen({
                                            innerElement: <ConfirmMallOpenDialog />,
                                        });
                                    }
                                } else {
                                    dialogOpen({
                                        title: '로그인이 필요합니다.',
                                        message: '로그인하러 갈까요?',
                                        onConfirmed: async () => {
                                            navigate('/login');
                                            dialogClear();
                                        },
                                        confirmText: '로그인하러 가기',
                                        disableBackdropClick: true,
                                        maxWidth: 'xs',
                                    });
                                }
                            }}
                            variant="contained"
                            color="sellerColorInvert"
                        >
                            몰 관리
                        </Button>
                    </div>
                </h1>
                {!!userId && (
                    <Button
                        onClick={toggleMenu}
                        type="button"
                        variant={'contained'}
                        sx={{ textTransform: 'none' }}
                        color={'black'}
                        className={'gradient'}
                        ref={menuTriggerRef}
                        startIcon={
                            <Avatar
                                src={profile_img_url || defaultUserImage}
                                alt={nickname || ''}
                                sx={{ width: 30, height: 30 }}
                                className="mr-1"
                            >
                                {nickname || ''}
                            </Avatar>
                        }
                        endIcon={<ExpandMoreIcon />}
                    >
                        {nickname}
                    </Button>
                )}
                {!userId && (
                    <Button
                        variant={'contained'}
                        color={'black'}
                        className={'gradient'}
                        startIcon={<LoginOutlined />}
                        href={'/login'}
                    >
                        로그인
                    </Button>
                )}
                <IconButton
                    onClick={() => {
                        setMode(mode === 'dark' ? 'light' : 'dark');
                    }}
                    sx={{ ml: 2 }}
                >
                    {mode !== 'dark' ? <DarkMode sx={{ color: '#ffffff' }} /> : <LightMode sx={{ color: '#ffffff' }} />}
                </IconButton>
                <AppBarExtendMenu
                    coverImgUrl={backgroundImage || ''}
                    open={isOpenExtend}
                    onClose={toggleMenu}
                    anchorEl={menuTriggerRef.current}
                    storeColor={backgroundColor || '#ebebeb'}
                >
                    <List component={'div'} sx={{ '& .MuiListItemIcon-root': { minWidth: 35 } }}>
                        <MenuItemLink to={'/logout'}>
                            <LogoutIcon sx={{ mr: 1 }} />
                            로그아웃
                        </MenuItemLink>
                        <Divider />
                        <ListItem>
                            <ListItemIcon>{mode === 'dark' ? <LightIcon /> : <DarkIcon />}</ListItemIcon>
                            <ListItemText>Change Mode</ListItemText>
                            <Box sx={{ ml: 1 }}>
                                <BasicSwitch
                                    checked={mode === 'dark'}
                                    onChange={(ev, value) => {
                                        setMode(mode === 'dark' ? 'light' : 'dark');
                                    }}
                                />
                            </Box>
                        </ListItem>
                    </List>
                </AppBarExtendMenu>
            </Toolbar>
        </MuiAppBar>
    );
};

export default AppBar;
